const BASE_URL = process.env.REACT_APP_BACKEND_URL;

let requestQueue = Promise.resolve();

export function queuedApiFetch(path, options = {}) {
  // Add to the queue
  requestQueue = requestQueue.then(() => apiFetch(path, options));
  return requestQueue;
}

export async function apiFetch(path, options = {}) {
  const url = `${BASE_URL}${path}`;
  const headers = { 'Content-Type': 'application/json', ...(options.headers || {}) };

  const res = await fetch(url, {
    ...options,
    headers,
    credentials: 'include'
  });

  if (res.status === 401 && !options._retry) {
    const refresh = await fetch(`${BASE_URL}/autodesk/refresh`, {
      method: 'POST',
      credentials: 'include'
    });

    if (refresh.ok) {
      return apiFetch(path, { ...options, _retry: true });
    } else {
      return new Response(
        JSON.stringify({ message: 'Unauthorized' }),
        { status: 401, headers: { 'Content-Type': 'application/json' } }
      );
    }
  }

  if (!res.ok) {
    const errorText = await res.text();
    return new Response(
      JSON.stringify({ message: errorText }),
      { status: res.status, headers: { 'Content-Type': 'application/json' } }
    );
  }

  return res.json();
}
